module.exports = __webpack_public_path__ + "img/ans-book.9b169796.svg";